import { Dialog, DialogTitle, DialogContent, Table, TableRow, TableCell, TableHead, TableBody } from "@mui/material";
import OpenInHomePageButton from "../searches/OpenInHomePageButton";
import { CloserFile } from "../settlementsDashboard/types";
import StickyTable from "../shared/StickyTable";

interface DealsDialogProps {
  onClose: () => void;
  open: boolean;
  orders: CloserFile[];
}

const renderTypeAbbreviation = (type: string) => {
  switch (type) {
    case "Purchase":
      return "P";
    case "Refinance":
      return "R";
    default:
      return type;
  }
};

function DealsDialog({ onClose, open, orders }: DealsDialogProps) {
  return (
    <Dialog onClose={onClose} open={open} maxWidth="lg" fullWidth>
      <DialogTitle>Current Deals</DialogTitle>
      <DialogContent dividers>
        <StickyTable size="small">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>File Number</TableCell>
              <TableCell>Deal Amount</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Client</TableCell>
              <TableCell>Sales Rep</TableCell>
              <TableCell>Funder</TableCell>
              <TableCell>Link</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{renderTypeAbbreviation(row.transactionType)}</TableCell>
                <TableCell>
                  {row.prefix ? `${row.prefix}-` : ""}
                  {row.number}
                </TableCell>
                <TableCell>{row.dealAmount?.toLocaleString("en-US", { style: "currency", currency: "USD" })}</TableCell>
                <TableCell>{row.state}</TableCell>
                <TableCell>{row.calculatedClient}</TableCell>
                <TableCell>{row.marketingRep}</TableCell>
                <TableCell>{row.funder}</TableCell>
                <TableCell>{row.number && <OpenInHomePageButton orderNumber={row.number} isLink />}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </StickyTable>
      </DialogContent>
    </Dialog>
  );
}

export default DealsDialog;
